import {Component, OnInit} from '@angular/core';

import {DataService} from '../../../services/data.service';
import {HomepageData, PageData} from '../../../services/data.model';

@Component({
  selector: 'app-homepage',
  templateUrl: './homepage.component.html',
  styleUrls: ['./homepage.component.scss']
})
export class HomepageComponent {

  public data: HomepageData = undefined;

  constructor(private dataService: DataService) {
    this.dataService.homepageData.subscribe((data: HomepageData) => this.data = data);
  }
}
